import React from 'react';
import PropTypes from 'prop-types';
import styles from './chapter-link.module.scss';

const ChapterLink = props => {
  if (!props.shouldRender) return null;
  return (
    <a
      target="_blank"
      className={styles.chapterLink}
      href={`${window.location.origin}/chapters/${props.chapterLink}`}
    >
      View Full Chapter{' '}
      <img alt="Right arrow" src={'/img/button-arrow-icon.svg'} />
    </a>
  );
};
ChapterLink.propTypes = {
  shouldRender: PropTypes.bool.isRequired,
  chapterLink: PropTypes.string.isRequired,
};
export default ChapterLink;



// WEBPACK FOOTER //
// ./src/components/accordion/chapter-link.js